import httpService from "./httpService";

const apiEndpoint = "/publish";

const isPublishInProgress = (projectCode: string) => {
  return httpService.get<boolean>(
    `${apiEndpoint}/isPublishInProgress?projectCode=${projectCode}`
  );
};

const publishService = {
  isPublishInProgress,
};

export default publishService;
